const DEFAULT_ENDPOINT = '/api/monitoring/client-log';

const isBrowser = typeof window !== 'undefined';

const normalizeError = (error) => {
  if (!error) return null;
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }
  return {
    name: 'UnknownError',
    message: typeof error === 'string' ? error : JSON.stringify(error),
  };
};

const emitToBackend = (payload) => {
  if (!isBrowser) return;

  const body = JSON.stringify(payload);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(DEFAULT_ENDPOINT, body);
    return;
  }

  fetch(DEFAULT_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {
    // Silent fail: telemetry must never break UX.
  });
};

export const logEvent = (level, message, context = {}) => {
  const payload = {
    level,
    message,
    context,
    source: 'frontend',
    href: isBrowser ? window.location.href : 'server',
    userAgent: isBrowser ? window.navigator.userAgent : 'n/a',
    timestamp: new Date().toISOString(),
  };

  if (process.env.NODE_ENV === 'development') {
    const logger = level === 'error' ? console.error : console.info;
    logger(`[monitoring:${level}] ${message}`, context);
  }

  emitToBackend(payload);
};

export const logError = (message, error, context = {}) => {
  logEvent('error', message, {
    ...context,
    error: normalizeError(error),
  });
};

export const initializeGlobalMonitoring = () => {
  if (!isBrowser) return;

  window.addEventListener('error', (event) => {
    logError('window_error', event?.error || event?.message || 'Unknown window error', {
      filename: event?.filename,
      lineno: event?.lineno,
      colno: event?.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    logError('unhandled_rejection', event?.reason || 'Unknown promise rejection');
  });
};
